import React, { memo, useState } from 'react';
import { Handle, Position } from 'reactflow';
import cx from 'classnames';

import PlusIconComponent from './PlusIconComponent';

import * as styles from '../styles.module.css';
import OptionListNodeContent from '../Contents/OptionListNodeContent';

const OptionListNode = ({
  id, data, sourcePosition, targetPosition
}) => {
  // id -> Es el id del node
  const [isDropzoneActive, setDropzoneActive] = useState(false);

  const onDrop = () => {
    setDropzoneActive(false);
  };

  const onDragOver = (evt) => {
    evt.preventDefault();
  };

  const onDragEnter = () => {
    setDropzoneActive(true);
  };

  const onDragLeave = () => {
    setDropzoneActive(false);
  };

  const onClick = (e) => {
    e.stopPropagation();
    data.addNode(id, data);
  };

  const handleEditNode = (e) => {
    e.stopPropagation();
    data.editNode(id);
  };

  const handleRemoveNode = () => {
    data.removeNode(id, data);
  };

  const className = cx(styles.node, { [styles.nodeDropzone]: isDropzoneActive });

  const displayPlusIcon = () => true;

  return (
    <>
      <div
        className={className}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
      >
        <Handle className={styles.handle} type="target" position={targetPosition || Position.Top} />
        <Handle className={styles.handle} type="source" position={sourcePosition || Position.Bottom} />
        <OptionListNodeContent
          nodeId={id}
          nodeData={data}
          editNode={handleEditNode}
          removeNode={handleRemoveNode}
        />
      </div>
      {displayPlusIcon() && (
        <PlusIconComponent onClick={onClick} />
      )}
    </>
  );
};

export default memo(OptionListNode);
